import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import timesheetService from '../../services/timesheetService'
import TimesheetForm from './TimesheetForm'

const TimesheetEdit = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [timesheetData, setTimesheetData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadTimesheetData()
  }, [id])

  const loadTimesheetData = async () => {
    try {
      setLoading(true)
      const response = await timesheetService.getTimesheetById(id)
      
      if (response.success && response.data) {
        setTimesheetData(response.data)
      } else {
        toast.error(response.message || 'Failed to load timesheet')
        navigate('/timesheets/list')
      }
    } catch (error) {
      console.error('Error loading timesheet:', error)
      toast.error('Failed to load timesheet')
      navigate('/timesheets/list')
    } finally {
      setLoading(false)
    }
  }

  const breadcrumbItems = [
    { label: 'Timesheets', path: '/timesheets', onClick: () => navigate('/timesheets') },
    { label: 'Timesheet List', path: '/timesheets/list', onClick: () => navigate('/timesheets/list') },
    { label: 'Edit Timesheet', path: `/timesheets/edit/${id}`, isCurrent: true }
  ]

  if (loading) {
    return (
      <div className="sales-dashboard">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading timesheet data...</p>
        </div>
      </div>
    )
  }

  if (!timesheetData) {
    return null
  }

  return (
    <TimesheetForm 
      mode="edit" 
      timesheetId={id} 
      initialData={timesheetData}
      breadcrumbItems={breadcrumbItems}
    />
  )
}

export default TimesheetEdit

